import React from 'react';
import styles from './subscriptionDetailsCard.module.css';

interface SubscriptionDetailsCardProps {
  isTrialTaken?: boolean;
  startingTodayAmount?: string;
  refundedTodayAmount?: string;
  futureStartDate?: string;
  futureAmount?: string;
  phoneNumber?: string;
  autopayDays?: number;
}

const SubscriptionDetailsCard: React.FC<SubscriptionDetailsCardProps> = ({
  isTrialTaken = false,
  startingTodayAmount = '₹2',
  refundedTodayAmount = '₹2',
  futureStartDate = '7 Nov, 2025',
  futureAmount = '₹549/90 days',
  phoneNumber = '+91 9899264235',
  autopayDays = 90,
}) => {
  return (
    <div className={styles.subscriptionCard}>
      <div className={styles.timelineContainer}>
        {/* Timeline Content */}
        <div className={styles.timelineContent}>
          {/* Starting today - only show if trial is taken */}
          {isTrialTaken && (
            <div className={styles.timelineItem}>
              <div className={styles.timelineDot} data-status="active"></div>
              <div className={styles.timelineText}>
                <span className={styles.timelineLabel}>Starting today</span>
                <span className={styles.timelineAmount}>{startingTodayAmount}</span>
              </div>
            </div>
          )}

          {/* Get refunded today - only show if trial is taken */}
          {isTrialTaken && (
            <div className={styles.timelineItem}>
              <div className={styles.timelineDot} data-status="active"></div>
              <div className={styles.timelineText}>
                <span className={styles.timelineLabel}>Get refunded today</span>
                <span className={styles.timelineAmount}>{refundedTodayAmount}</span>
              </div>
            </div>
          )}

          {/* Starting date and subscription */}
          <div className={styles.timelineItemGroup}>
            <div className={styles.timelineItem}>
              <div className={styles.timelineDot} data-status="inactive"></div>
              <div className={styles.timelineText}>
                <span className={styles.timelineLabelInactive}>Starting {futureStartDate}</span>
                <span className={styles.timelineAmountInactive}>{futureAmount}</span>
              </div>
            </div>
            <div className={styles.subscriptionInfo}>
              <p>Subscription will be activated on</p>
              <p>{phoneNumber}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className={styles.divider}></div>

      {/* Autopay Info */}
      <div className={styles.autopayInfo}>
        <div className={styles.autopayText}>
          <span className={styles.autopayLabel}>Autopay every {autopayDays} days,</span>
          <span className={styles.cancelAnytime}>Cancel anytime</span>
        </div>
        <p className={styles.notificationText}>We will notify you 24hrs before auto debit happens</p>
      </div>
    </div>
  );
};

export default SubscriptionDetailsCard;

